import React from 'react'
import { AreaEditorProps, DashboardAreaKeys } from '../../types'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import DashboardArea from '../DashboardArea'
import { DASHBOARD_EDITOR_CURRENT_VALUES_AREA_ID } from 'src/Libs/qa/ids'

/**
 * Current values area for the dashboard editor
 */
const CurrentValuesArea: React.FC<AreaEditorProps> = ({ hidden, setHidden, position, getMenuItems, disabled }) => {
  const { t } = useCustomTranslation()

  return (
    <DashboardArea
      areaKey={DashboardAreaKeys.currentValues}
      name={t('dashboard.editor.current-values')}
      hidden={hidden}
      setHidden={setHidden}
      position={position}
      getMenuItems={getMenuItems}
      disabled={disabled}
      dataQa={DASHBOARD_EDITOR_CURRENT_VALUES_AREA_ID}
    />
  )
}

export default CurrentValuesArea
